import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhysicalOceanography = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 49,
	viewBox: "0 0 60 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1238_22306)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M39.1301 41.8701C36.7401 43.8901 33.8901 45.4601 30.6901 46.4001C18.4101 50.0001 5.54006 42.9601 1.94006 30.6801C-1.65994 18.4001 5.38006 5.54006 17.6601 1.94006C29.9401 -1.65994 42.8101 5.38006 46.4101 17.6601C47.1301 20.1301 47.4301 22.6301 47.3301 25.0701",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.65015 21.0303H10.0601C11.9701 21.0303 13.5301 22.5803 13.5301 24.5003V24.8703C13.5301 26.7803 11.9801 28.3403 10.0601 28.3403H9.30015C7.60015 28.3403 6.22015 29.7203 6.22015 31.4203V31.6503C6.22015 33.3503 7.60015 34.7303 9.30015 34.7303H18.1301C20.6301 34.7303 22.6501 36.7603 22.6501 39.2503V47.5103",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.65 7.51025H37.66C35.5 7.51025 33.51 8.96025 33.08 11.0803C32.5 13.9703 34.7 16.5103 37.49 16.5103H45.65",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.3899 26.1802C56.8299 26.1802 56.8299 28.3002 54.2599 28.3002C51.6899 28.3002 51.6999 26.1802 49.1299 26.1802C46.5599 26.1802 46.5699 28.3002 44.0099 28.3002C41.4499 28.3002 41.4499 26.1802 38.8799 26.1802C36.3099 26.1802 36.3199 28.3002 33.7599 28.3002C31.1999 28.3002 31.1999 26.1802 28.6399 26.1802V32.8402C31.1999 32.8402 31.1999 34.9602 33.7599 34.9602C36.3199 34.9602 36.3199 32.8402 38.8799 32.8402C41.4399 32.8402 41.4399 34.9602 44.0099 34.9602C46.5799 34.9602 46.5699 32.8402 49.1299 32.8402C51.6899 32.8402 51.6899 34.9602 54.2599 34.9602C56.8299 34.9602 56.8199 32.8402 59.3899 32.8402V26.1802Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.6799 24.5098C28.2399 24.5098 28.2399 26.6298 30.7999 26.6298C33.3599 26.6298 33.3599 24.5098 35.9199 24.5098C38.4799 24.5098 38.4799 26.6298 41.0499 26.6298C43.6199 26.6298 43.6099 24.5098 46.1699 24.5098C48.7299 24.5098 48.7299 26.6298 51.2999 26.6298C53.8699 26.6298 53.8599 24.5098 56.4299 24.5098",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.6799 30.1597C28.2399 30.1597 28.2399 32.2797 30.7999 32.2797C33.3599 32.2797 33.3599 30.1597 35.9199 30.1597C38.4799 30.1597 38.4799 32.2797 41.0499 32.2797C43.6199 32.2797 43.6099 30.1597 46.1699 30.1597C48.7299 30.1597 48.7299 32.2797 51.2999 32.2797C53.8699 32.2797 53.8599 30.1597 56.4299 30.1597",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.9199 35.8198C38.4799 35.8198 38.4799 37.9398 41.0499 37.9398C43.6199 37.9398 43.6099 35.8198 46.1699 35.8198",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1238_22306",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 59.39,
			height: 48.34,
			fill: "white"
		})
	}) })]
});
export default SvgPhysicalOceanography;
